import { CheckCircle2, Circle, ClipboardCheck } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { taxChecklist } from "../lib/finance";
import { dateLabel, today } from "../lib/format";
import { Section } from "./common";
import { Progress } from "./ui/progress";
import { cn } from "../lib/utils";

export default function TaxChecklist({ year }) {
  const { state, update } = useStore();
  const c = taxChecklist(state, year);
  const toggle = (id, on) =>
    update(`Tax checklist: ${id}`, (d) => {
      const cur = { ...(d.taxChecklist?.[year] || {}) };
      if (on) cur[id] = today();
      else delete cur[id];
      d.taxChecklist = { ...(d.taxChecklist || {}), [year]: cur };
    });
  return (
    <Section title={`Tax season checklist · ${year}`} subtitle="Receipts and trips tick themselves when they're done. Tick the rest as you go." action={<ClipboardCheck className="h-5 w-5 text-primary" />} testid="tax-checklist">
      <div className="flex items-center gap-3 mb-3">
        <Progress value={(c.done / c.total) * 100} className="h-2.5 flex-1" />
        <span className="text-sm font-semibold num" data-testid="tax-checklist-progress">{c.done} of {c.total} done</span>
      </div>
      <ul className="divide-y">
        {c.items.map((i) => (
          <li key={i.id} className="py-2.5 flex items-center gap-3 text-sm" data-testid={`tax-check-${i.id}`}>
            <button type="button" disabled={i.auto} onClick={() => toggle(i.id, !i.done)} className={cn("shrink-0 transition-transform", !i.auto && "hover:scale-110")} aria-label={i.done ? "Mark not done" : "Mark done"} data-testid={`tax-check-toggle-${i.id}`}>
              {i.done ? <CheckCircle2 className="h-5 w-5 text-income" /> : <Circle className="h-5 w-5 text-muted-foreground" />}
            </button>
            <span className={cn("flex-1", i.done && "text-muted-foreground line-through decoration-1")}>{i.label}</span>
            <span className="text-xs text-muted-foreground text-right" data-testid={`tax-check-detail-${i.id}`}>{i.auto ? <>{i.detail} · <span className="italic">auto</span></> : i.date ? `Done ${dateLabel(i.date)}` : ""}</span>
          </li>
        ))}
      </ul>
    </Section>
  );
}
